import React from 'react';

import { useParams } from 'react-router-dom';

import routes from 'app/routes';

import { useContext as useHomeContext } from 'components/Members/Home/Context';

import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

import useProgram from 'components/Common/Programs/Hooks/useProgram';
import useStep from 'components/Common/Programs/Hooks/useStep';
import useStepResource from 'components/Common/Programs/Hooks/useStepResource';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Index() {
  const { programId, stepId, resourceId } = useParams();

  const homeContext = useHomeContext();

  const program = useProgram(programId);
  const step = useStep(stepId);
  const resource = useStepResource(stepId, resourceId);

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: program?.attributes?.title,
      path: routes.members.programs.show(programId),
    },
    {
      name: step?.attributes?.title,
    },
  ];

  if (program === null || step === null || resource === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="content">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}

      <section>
        <h1>{resource.attributes.title}</h1>
      </section>
      <section>
        <div dangerouslySetInnerHTML={{ __html: resource.attributes.content }} />
      </section>
    </div>
  );
}
